import { Link } from "react-router-dom";
import WishlistEmpty from "../../../assets/images/empty-wishlist.webp";
import CartEmpty from "../../../assets/images/empty-cart.png";

const LoginWarning = () => {
  return (
    <div className="text-center py-80 warning-page">
      <i className="ph ph-warning text-warning-600 mb-16 warning-page__icon" />
      <h4 className="mb-16">Please Login to Continue</h4>
      <p className="text-neutral-600 mb-24">
        You need to be logged in to access this page
      </p>
      <button
        className="btn btn-main rounded-pill warning-page__btn"
        onClick={() => {
          window.showLoginModal?.();
          return;
        }}
      >
        Login Now
      </button>
    </div>
  );
};

export const EmptyCart = () => {
  return (
    <div className="text-center py-80 warning-page">
      <div className="mb-24 warning-page__img">
        <img src={CartEmpty} className="empty-img" />
      </div>
      <h3 className="mb-12">Your Cart is Empty</h3>
      <p className="text-neutral-600 mb-32 max-w-md mx-auto">
        Looks like you haven't added anything to your cart yet. Start shopping
        and discover our fresh seafood!
      </p>
      <Link to="/" className="btn btn-main rounded-pill warning-page__btn">
        <i className="ph ph-storefront me-8" />
        Start Shopping
      </Link>
    </div>
  );
};

export const EmptyWishlist = () => {
  return (
    <div className="text-center py-80 warning-page">
      <div className="mb-24 warning-page__img">
        <img src={WishlistEmpty} className="empty-img" />
      </div>
      <h3 className="mb-12">Your Wishlist is Empty</h3>
      <p className="text-neutral-600 mb-32 max-w-md mx-auto">
        Save your favorite items here and never lose track of what you love!
      </p>
      <Link
        to="/collections"
        className="btn btn-main rounded-pill warning-page__btn"
      >
        <i className="ph ph-fish me-8" />
        Explore Products
      </Link>
    </div>
  );
};

export const EmptyProducts = () => {
  return (
    <div className="text-center py-80 product-empty-warning-page">
      <span className="warning-page__icon warning-page__icon--neutral mb-16">
        <i className="ph ph-package" />
      </span>
      <h4 className="mb-12">No Products Found</h4>
      <p className="text-neutral-600 mb-24">
        There are no products in this category yet.
      </p>
      <Link
        to="/collections"
        className="btn btn-main rounded-pill warning-page__btn"
      >
        <i className="ph ph-grid-four me-8" />
        Browse Collections
      </Link>
      <Link to="/" className="warning-page__secondary">
        <i className="ph ph-house" />
        Back to Home
      </Link>
    </div>
  );
};

export default LoginWarning;
